import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { submit, initialize, change, destroy, reset } from 'redux-form';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { LoadingBase } from 'Components';
import { Main, Filter } from 'Containers/';
import {
  EDIT_RECIPE_FORM_NAME,
  EDIT_INGREDIENT_FORM_NAME,
  RECIPE_PREPARATION_FORM_NAME,
} from 'Common/FormEnum';
import {
  RecipeFieldEnum as Fields,
  IngredientFieldEnum as IngredientFields,
  RecipePreparationReportEnum,
} from 'Common/FieldEnum';
import { withRecipesSubscription } from 'Common/Components/RecipeSearch';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import {
  errorToast,
  createToast,
  toastType,
  createCustomToastFromError,
} from 'Common/ToastHelper';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';
import * as DialogActions from 'Components/dialogs/state/actions';
import MPWWebApi from 'API/MPWApi';
import * as ReportActions from 'State/report/actions';
import { RecipePreparationReportModal } from 'Pages/managerecipe/components/RecipePreparationReportModal';
import { IngredientModal } from 'Pages/manageingredient/subpages/editingredient/components/IngredientModal';

import { EditRecipeForm } from './EditRecipeForm';
import * as EditRecipeSelectors from '../../state/editrecipe/selectors';
import * as EditRecipeActions from '../../state/editrecipe/actions';

class EditRecipeContainer extends Component {
  static propTypes = {
    openedInModal: PropTypes.bool,
  };

  static defaultProps = {
    openedInModal: false,
  };

  get initialValues() {
    return {
      [Fields.Name]: '',
      [Fields.Description]: '',
      [Fields.MarketingDescription]: '',
      [Fields.RecipeCategoryId]: null,
      [Fields.HACCPId]: null,
      [Fields.ServingTemperatureId]: null,
      [Fields.RecipeSourceId]: 1,
      [Fields.GroupId]: null,
      [Fields.LeftoverDays]: 3,
      [Fields.Inactive]: 'N',
      [Fields.Picture]: '',
      [Fields.Ingredients]: [],
      [Fields.Allergens]: [],
      [Fields.AllAllergens]: [],
      [Fields.TargetTemp]: '',
      [Fields.HoldTemp]: '',
    };
  }

  state = {
    showRecipePrepModal: false,
    ingredientModalIngredientId: null,
  };

  onRecipePrepModalClose = () => {
    const { reset } = this.props;
    reset(RECIPE_PREPARATION_FORM_NAME);
    this.setState({ showRecipePrepModal: false });
  };
  updateRecipePrep = () => {
    const { initialize, formValues, recipeId } = this.props;
    initialize(RECIPE_PREPARATION_FORM_NAME, {
      [RecipePreparationReportEnum.RecipeId]: recipeId,
      [RecipePreparationReportEnum.QtyOfPortion]:
        formValues[Fields.QtyOfPortion],
      [RecipePreparationReportEnum.MeasureOfPortion]:
        formValues[Fields.MeasureOfPortion],
      [RecipePreparationReportEnum.DefaultNumberOfPortion]:
        formValues[Fields.NumberOfPortion],
      [RecipePreparationReportEnum.NumberOfPortion]:
        formValues[Fields.NumberOfPortion],
      [RecipePreparationReportEnum.LockBatch]: formValues[Fields.LockBatch],
      [RecipePreparationReportEnum.Batches]: 1,
    });
  };
  openRecipePrepModal = () => {
    this.updateRecipePrep();
    this.setState({ showRecipePrepModal: true });
  };
  onRecipePrepModalOpen = () => {
    const {
      isRecipeFormDirty,
      setNotificationDialog,
      isRecipeFormValid,
      formValues,
    } = this.props;

    if (
      !formValues[Fields.QtyOfPortion] ||
      !_.trim(formValues[Fields.MeasureOfPortion])
    ) {
      createToast(
        toastType.error,
        'Error',
        'Please enter serving size and serving unit before viewing preparation report.'
      );
      return;
    }

    if (isRecipeFormDirty) {
      setNotificationDialog({
        ...NOTIFICATION_DIALOG_MESSAGES.EDIT_RECIPE_VIEW_PREP_FORM_DIRTY,
        actionsToDispatchOnOk: [submit(EDIT_RECIPE_FORM_NAME)],
        ...(isRecipeFormValid && {
          functionsToRunOnOk: [this.openRecipePrepModal],
        }),
      });
    } else {
      this.openRecipePrepModal();
    }
  };

  handleSaveRecipe = async (values) => {
    const { saveRecipe, fetchError, fetchInfo, formValues, change } =
      this.props;
    const fatChange = parseFloat(formValues[Fields.FatChange]) || 0;
    const typeOfFat = formValues[Fields.TypeOfFat];

    if (fatChange && !typeOfFat) {
      createToast(
        toastType.error,
        'Error',
        'You must select a fat ingredient.',
        true
      );
      return;
    }

    const result = await saveRecipe(formValues);

    if (result) {
      createToast(toastType.success, 'Success', 'Saved Successfully.', true);
      change(EDIT_RECIPE_FORM_NAME, Fields.Id, result);
    } else if (fetchInfo) {
      createToast(toastType.info, 'Notification', fetchError.Message, true);
    } else if (fetchError) {
      createToast(toastType.error, 'Error', fetchError.Message, true);
    }
  };

  getRecipeNutritionFacts = () => {
    const { formValues, getRecipeNutritionFacts } = this.props;
    getRecipeNutritionFacts(formValues);
  };

  handleGetRecipeNutritionFacts = _.debounce(
    this.getRecipeNutritionFacts,
    250,
    { leading: false, trailing: true }
  );

  getRecipePrepReport = (values) => {
    const { getReport } = this.props;
    const data = {
      Recipes: [values],
    };
    getReport('Reports/RecipePreparationReport', data);
  };

  getMainProps = () => {
    const { openedInModal, recipeId, nutritionFactsFetching, isReadOnly } =
      this.props;
    return {
      toolbox: {
        formName: EDIT_RECIPE_FORM_NAME,
        shown: true,
        backButtonProps: {
          shown: !openedInModal,
          path: '/managerecipe',
          callback: this.onBackClick,
          watchedForm: EDIT_RECIPE_FORM_NAME,
        },
        saveButtonProps: {
          content: 'Save',
          disabled: nutritionFactsFetching || isReadOnly,
        },
        ...(recipeId && {
          rightButtons: [
            {
              content: 'Scale Recipe / View Preparation Report',
              onClick: this.onRecipePrepModalOpen,
            },
          ],
        }),
      },
      shouldNotUsePageWidth: true,
      width: {
        width: 16,
      },
    };
  };

  onRecipeImageDrop = (files) => {
    const { change } = this.props;
    if (files[0] !== undefined && files[0] !== 0) {
      change(EDIT_RECIPE_FORM_NAME, Fields.PicturePreview, files[0]);
    }
  };

  onRecipeImageRemove = () => {
    const { change } = this.props;
    change(EDIT_RECIPE_FORM_NAME, Fields.Picture, '');
  };

  handleToggleActive = () => {
    const { formValues, setNotificationDialog } = this.props;
    let value = 'N';
    let message = NOTIFICATION_DIALOG_MESSAGES.RECIPE_ACTIVE;

    if (formValues[Fields.Inactive] === 'N') {
      value = 'Y';
      message = NOTIFICATION_DIALOG_MESSAGES.RECIPE_INACTIVE;
    }

    setNotificationDialog({
      ...message,
      actionsToDispatchOnOk: [
        change(EDIT_RECIPE_FORM_NAME, Fields.Inactive, value),
      ],
    });
  };

  convertRecipeToIngredient = () => {
    const { formValues, setNotificationDialog } = this.props;
    if (!formValues[Fields.Id]) {
      createToast(
        toastType.error,
        'Error',
        'You must create your recipe first.',
        true
      );
      return;
    }
    setNotificationDialog({
      ...NOTIFICATION_DIALOG_MESSAGES.CONVERT_RECIPE,
      actionsToDispatchOnOk: [
        EditRecipeActions.convertRecipeToIngredient(formValues),
      ],
    });
  };

  openIngredientModal = (ingredientId, closeAddIngredientModal) => {
    const {
      submit,
      change,
      isRecipeFormDirty,
      isRecipeFormValid,
      setShowIngredientModal,
    } = this.props;
    change(EDIT_INGREDIENT_FORM_NAME, IngredientFields.Id, ingredientId);
    setShowIngredientModal(true);
    this.setState({ ingredientModalIngredientId: ingredientId });

    if (isRecipeFormDirty || !isRecipeFormValid) {
      submit(EDIT_RECIPE_FORM_NAME);

      if (!isRecipeFormValid) {
        closeAddIngredientModal();
      }
    }
  };

  closeIngredientModal = () => {
    const { setShowIngredientModal } = this.props;
    setShowIngredientModal(false);
  };

  onSaveClose = () => {
    const { formValues, setShowIngredientModal } = this.props;
    const { ingredientModalIngredientId } = this.state;

    var recipeIngredient = formValues.Ingredients;

    var ingredientOnRecipe =
      recipeIngredient &&
      recipeIngredient.find((ing) => ing.Id === ingredientModalIngredientId);

    setShowIngredientModal(false);
    this.setState({ ingredientModalIngredientId: null });

    if (ingredientOnRecipe) {
      this.getRecipe();
    }
  };

  get recipeId() {
    const { match, recipeId } = this.props;
    if (recipeId) {
      return recipeId;
    } else if (match.params.id) {
      return match.params.id;
    }
  }

  getRecipe = async () => {
    const { getRecipe } = this.props;
    const recipeId = this.recipeId;
    if (recipeId) {
      await getRecipe(recipeId);
    }
  };

  async componentDidMount() {
    const { initialize } = this.props;
    const recipeId = this.recipeId;
    if (recipeId) {
      await this.getRecipe();
    } else {
      const allergenResponse = await MPWWebApi.getGeneric(`Allergen`);
      const attributeResponse = await MPWWebApi.getGeneric(`Attribute`);
      let initialValues = { ...this.initialValues };
      initialValues[Fields.AllAllergens] = allergenResponse.data.Data;
      initialValues[Fields.AllAttributes] = attributeResponse.data.Data;
      initialize(EDIT_RECIPE_FORM_NAME, initialValues);
    }
  }

  componentWillUnmount() {
    const { destroy } = this.props;
    destroy(EDIT_RECIPE_FORM_NAME);
  }

  componentDidUpdate(prevProps) {
    const {
      convertSuccessful,
      setConvertToIngredientSuccessful,
      setShowIngredientModal,
      showIngredientModal,
      isRecipeFormValid,
    } = this.props;

    if (errorToast(this.props, prevProps, 'fetchError')) {
      this.props.clearErrors();
    }

    if (
      createCustomToastFromError(
        this.props,
        prevProps,
        'fetchInfo',
        'Notification',
        toastType.info
      )
    ) {
      this.props.clearInfo();
    }

    if (convertSuccessful) {
      setShowIngredientModal(true);
      setConvertToIngredientSuccessful(null);
    }

    if (!isRecipeFormValid && showIngredientModal) {
      setShowIngredientModal(false);
    }
  }

  render() {
    const { showRecipePrepModal } = this.state;
    const {
      loading,
      isRecipeFormDirty,
      recipeSaveSuccessful,
      displayIngredientModal,
      isReadOnly,
      recipeId,
      newRecipeId,
      ...rest
    } = this.props;
    if (loading) {
      return <LoadingBase />;
    }

    return (
      <Fragment>
        <Filter title="Add / Edit Recipe" />
        <Main {...this.getMainProps()}>
          <EditRecipeForm
            onSubmit={this.handleSaveRecipe}
            onRecipeImageDrop={this.onRecipeImageDrop}
            onRecipeImageRemove={this.onRecipeImageRemove}
            handleToggleActive={this.handleToggleActive}
            handleGetRecipeNutritionFacts={this.handleGetRecipeNutritionFacts}
            openIngredientModal={this.openIngredientModal}
            convertRecipeToIngredient={this.convertRecipeToIngredient}
            isReadOnly={isReadOnly}
            recipeId={!recipeId ? newRecipeId : recipeId}
            {...rest}
          />
          <RecipePreparationReportModal
            onSubmit={this.getRecipePrepReport}
            headerTitle="Scale Recipe / View Preparation Report"
            modalProps={{
              size: 'large',
              open: showRecipePrepModal,
              onClose: this.onRecipePrepModalClose,
            }}
          />
        </Main>
        <IngredientModal
          onSaveClose={this.onSaveClose}
          modalProps={{
            size: 'fullscreen',
            open: displayIngredientModal,
            onClose: this.closeIngredientModal,
            closeOnDimmerClick: false,
            closeOnEscape: false,
          }}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  if (ownProps.setPageLevelDirty) {
    ownProps.setPageLevelDirty(getIsDirty()(state));
  }
  return {
    fetchError: EditRecipeSelectors.getFetchError(state),
    fetchInfo: EditRecipeSelectors.getFetchInfo(state),
    loading: EditRecipeSelectors.getFetching(state),
    recipeId: EditRecipeSelectors.getRecipeFormValue(state, Fields.Id),
    recipeImage: EditRecipeSelectors.getRecipeFormValue(state, Fields.Picture),
    formValues: EditRecipeSelectors.getRecipeFormValues(state) || {},
    initialFormValues:
      EditRecipeSelectors.getRecipeInitialFormValues(state) || {},
    submitFailed: EditRecipeSelectors.getHasSubmitFailed(state),
    userModifiedAllergens: EditRecipeSelectors.getUserModifiedAllergens(state),
    userModifiedAttributes:
      EditRecipeSelectors.getUserModifiedAttributes(state),
    userModifiedMealComponents:
      EditRecipeSelectors.getUserModifiedMealComponents(state),
    isRecipeFormDirty: EditRecipeSelectors.isDirtySelector(state),
    isRecipeFormValid: EditRecipeSelectors.isValidSelector(state),
    convertSuccessful: EditRecipeSelectors.getConvertSuccessful(state),
    hasSubRecipes: EditRecipeSelectors.hasSubRecipes(state),
    nutritionFactsFetching:
      EditRecipeSelectors.getNutritionFactsFetching(state),
    recipeSaveSuccessful: EditRecipeSelectors.getSaveSuccessful(state),
    showIngredientModal: EditRecipeSelectors.getShowIngredientModal(state),
    displayIngredientModal:
      EditRecipeSelectors.getDisplayIngredientModal(state),
    isReadOnly: EditRecipeSelectors.getIsReadOnly(state),
    newRecipeId: EditRecipeSelectors.getNewRecipeId(state),
  };
};

const mapDispatchToProps = {
  submit,
  initialize,
  change,
  destroy,
  reset,
  getRecipe: EditRecipeActions.getRecipe,
  saveRecipe: EditRecipeActions.saveRecipe,
  clearErrors: EditRecipeActions.clearErrors,
  clearInfo: EditRecipeActions.clearInfo,
  setNotificationDialog: DialogActions.setNotificationDialog,
  getRecipeNutritionFacts: EditRecipeActions.getRecipeNutritionFacts,
  getReport: ReportActions.getReport,
  setConvertToIngredientSuccessful:
    EditRecipeActions.setConvertToIngredientSuccessful,
  setShowIngredientModal: EditRecipeActions.setShowIngredientModal,
};

const EditRecipe = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRecipesSubscription(EditRecipeContainer))
);

// See https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
// for why this is not part of the component
EditRecipe.path = '/managerecipe/edit/:id?';

export { EditRecipe };



// WEBPACK FOOTER //
// ./src/pages/managerecipe/subpages/editrecipe/EditRecipe.js